import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const GetErrorMessage = ({
  urlId,
  provisionIdParam,
  isMissingFields,
  partnerConfig,
  flow,
}) => {
  const { isPull, text } = partnerConfig;
  if (flow === 'logout') {
    return (
      <div
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Large circle indeterminate"
        className="progress-circle progress-indeterminate progress-lg"
      />
    );
  }
  if (isMissingFields) {
    return (
      <FormattedMessage id="card.details.missing.message" defaultMessage="Card details missing." />
    );
  }

  if (isPull && text !== 'BPAY' && !urlId) {
    return (
      <FormattedMessage id="urlid.required.message" defaultMessage="Url Id required for login." />
    );
  }

  if (isPull && text === 'BPAY' && !provisionIdParam) {
    return (
      <FormattedMessage
        id="provisionId.required.message"
        defaultMessage="Provision Id required for login."
      />
    );
  }

  return (
    <FormattedMessage
      id="authcode.required.message"
      defaultMessage="{partnerText} Authorization Code required for login."
      values={{
        partnerText: partnerConfig.text,
      }}
    />
  );
};

GetErrorMessage.propTypes = {
  urlId: PropTypes.string,
  provisionIdParam: PropTypes.string,
  isMissingFields: PropTypes.bool,
  partnerConfig: PropTypes.shape({
    isPull: PropTypes.bool,
    text: PropTypes.string,
  }),
  flow: PropTypes.string,
};
